import { useSyncExternalStore } from "react";

import { Sheet, SheetContent, SheetTitle } from "./sheet";
import {
  closeDrawer,
  DrawerSize,
  getDrawerSnapshot,
  subscribeToDrawer,
} from "./use-drawer";

import { cn } from "@/lib/utils/cn";

const sizeClasses: Record<DrawerSize, string> = {
  small: "sm:max-w-md",
  medium: "w-full sm:w-1/2 sm:max-w-none",
};

/**
 * Renders the single app-wide drawer driven by the use-drawer store.
 * Mount once at the app root. No provider or context needed.
 */
export const DrawerRoot = () => {
  const { isOpen, content, title, size } = useSyncExternalStore(
    subscribeToDrawer,
    getDrawerSnapshot
  );

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && closeDrawer()}>
      <SheetContent className={cn("gap-0 overflow-y-auto p-0", sizeClasses[size])}>
        <SheetTitle className="sr-only">{title}</SheetTitle>
        {content}
      </SheetContent>
    </Sheet>
  );
};
